import { includes } from 'lodash'
import { AccountDetails, IndividualAccountRegistrations } from '../../types'

const ISOALPHA3_CODE_USA = 'USA'

const accountHasDob = (accountDetails: AccountDetails) =>
  !!accountDetails.dateOfBirth

const accountIsIndividual = (accountDetails: AccountDetails) =>
  includes(IndividualAccountRegistrations, accountDetails.accountRegistration)

const hasNoCountryOrHasUsAddress = (accountDetails: AccountDetails) =>
  !accountDetails.accountAddress?.country ||
  accountDetails.accountAddress?.country === ISOALPHA3_CODE_USA

export const isCustomerUpdateAllowedForAccount = (
  accountDetails?: AccountDetails
): boolean =>
  !!accountDetails &&
  accountHasDob(accountDetails) &&
  accountIsIndividual(accountDetails) &&
  hasNoCountryOrHasUsAddress(accountDetails)
